module.exports = __webpack_public_path__ + "static/media/matching-score-rank-7.5300b988.png";